var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form_step_2",
      model: {
        value: _vm.form,
        callback: function ($$v) {
          _vm.form = $$v
        },
        expression: "form",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "mt-5 mb-5" },
        [
          _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
            _c("h4", { staticClass: "m-0" }, [_vm._v("Confirm Reservation")]),
          ]),
          _vm._v(" "),
          _vm.$store.state.model.reservation.group_link_id
            ? [
                _c("v-row", [_c("v-col", [_c("ticket-information")], 1)], 1),
                _vm._v(" "),
                _c("v-row", [_c("v-col", [_c("rental-information")], 1)], 1),
              ]
            : [
                _vm.discounted_dates.length !== 0 &&
                !_vm.$store.state.model.reservation.is_delivery &&
                this.config.module_type_enabled != 0 &&
                this.config.module_type == "module_1"
                  ? _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
                      _c(
                        "h6",
                        { staticClass: "m-0 red--text" },
                        [
                          _vm._v(
                            "\n                    NOTE: We have disabled discount on some dates: "
                          ),
                          _vm._l(_vm.discounted_dates, function (date, index) {
                            return [
                              _vm._v(
                                _vm._s(date["start"]) +
                                  " to " +
                                  _vm._s(date["end"]) +
                                  "\n            vscode-file://vscode-app/private/var/folders/8t/q34rd6393c368rx6t1l5wzw80000gn/T/AppTranslocation/C48FCADD-5376-40FA-A582-33C06D8946E4/d/Visual%20Studio%20Code%202.app/Contents/Resources/app/out/vs/code/electron-sandbox/workbench/workbench.html      "
                              ),
                              _vm.discounted_dates.length > 0 &&
                              index + 1 < _vm.discounted_dates.length
                                ? _c("span", [_vm._v(", ")])
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-row",
                  [
                    _c("v-col", [_c("ticket-information")], 1),
                    _vm._v(" "),
                    _c("v-col", [_c("rental-information")], 1),
                  ],
                  1
                ),
              ],
          _vm._v(" "),
          _vm.notes_in_advance ? _c("additional-information") : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("renters-list-table", {
        staticClass: "mt-2",
        attrs: { title: "Renters list", "no-action": true },
      }),
      _vm._v(" "),
      !_vm.$store.state.model.reservation.group_link_id
        ? [
            _vm.gateway == "stripe"
              ? [
                  !_vm.cost.free_checkout && _vm.skip_checkout == 0
                    ? [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            (
                              _vm.is_prepay
                                ? _vm.prepay_payment ||
                                  _vm.only_save_card_at_prepay
                                : _vm.only_save_card_at_advanced ||
                                  _vm.advance_reservation_payment_checkout
                            )
                              ? _c(
                                  "v-card",
                                  { staticClass: "mt-5" },
                                  [
                                    _c(
                                      "v-card-title",
                                      { staticClass: "grey lighten-4 p-2" },
                                      [
                                        (!_vm.is_prepay &&
                                          _vm.only_save_card_at_advanced) ||
                                        (_vm.is_prepay &&
                                          _vm.only_save_card_at_prepay)
                                          ? _c(
                                              "h5",
                                              {
                                                staticClass:
                                                  "m-0 font-weight-bold text-break",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            Please enter your credit card to save this reservation, you will not be charged at this time\n                        "
                                                ),
                                              ]
                                            )
                                          : _c("h4", { staticClass: "m-0" }, [
                                              _vm._v(
                                                "\n                            Reservation Total: "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "blue--text text--accent-4",
                                                },
                                                [
                                                  _vm._v(
                                                    "$" + _vm._s(_vm.amount)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.charge_50_percent ||
                                              _vm.charge_25_percent ||
                                              _vm.charge_10_percent ||
                                              _vm.charge_10_per_person ||
                                              _vm.charge_20_per_person ||
                                              _vm.charge_30_per_person
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "error--text text-break text--accent-4",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                ( " +
                                                          _vm._s(
                                                            _vm.deposite_text
                                                          ) +
                                                          " )\n                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-2" }, [
                                      (!_vm.is_prepay &&
                                        _vm.only_save_card_at_advanced) ||
                                      (_vm.is_prepay &&
                                        _vm.only_save_card_at_prepay)
                                        ? _c("h4", { staticClass: "m-0" }, [
                                            _c(
                                              "span",
                                              { staticClass: "error--text" },
                                              [_vm._v(" Reservation Total:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4",
                                              },
                                              [_vm._v("$" + _vm._s(_vm.amount))]
                                            ),
                                            _vm._v(" "),
                                            _vm.charge_50_percent ||
                                            _vm.charge_25_percent ||
                                            _vm.charge_10_percent ||
                                            _vm.charge_10_per_person ||
                                            _vm.charge_20_per_person ||
                                            _vm.charge_30_per_person
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "error--text text-break text--accent-4",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                ( " +
                                                        _vm._s(
                                                          _vm.deposite_text
                                                        ) +
                                                        " )\n                            "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.advance_reservation_payment_checkout &&
                                        !_vm.charge_50_percent &&
                                        !_vm.charge_25_percent &&
                                        !_vm.charge_10_percent &&
                                        !_vm.charge_10_per_person &&
                                        !_vm.charge_20_per_person &&
                                        !_vm.charge_30_per_person &&
                                        !_vm.only_save_card_at_advanced) ||
                                      (_vm.is_prepay &&
                                        _vm.prepay_payment &&
                                        !_vm.only_save_card_at_prepay)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mt-5 error--text text-break",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Please enter your credit card information to complete the reservation\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        attrs: { id: "card-element" },
                                      }),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("with-validation", {
                              attrs: { field: "agreement" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ bind, on }) {
                                      return [
                                        (
                                          _vm.is_prepay
                                            ? _vm.prepay_payment ||
                                              _vm.only_save_card_at_prepay
                                            : _vm.only_save_card_at_advanced ||
                                              _vm.advance_reservation_payment_checkout
                                        )
                                          ? _c(
                                              "v-checkbox",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function () {
                                                            return [
                                                              _vm._v(
                                                                "\n                            I have read and agree to the\n                            "
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        $event.preventDefault()
                                                                        return _vm.ui__openModalByName(
                                                                          {
                                                                            name: "dialog_terms",
                                                                          }
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.terms_and_conditions_title
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                ",\n                            "
                                                              ),
                                                              _vm.show_sms_consent
                                                                ? _c("span", [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: "#",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              $event.preventDefault()
                                                                              return _vm.ui__openModalByName(
                                                                                {
                                                                                  name: "dialog_sms_consent",
                                                                                }
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.sms_constent_title
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      ",\n                            "
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        $event.preventDefault()
                                                                        return _vm.ui__openModalByName(
                                                                          {
                                                                            name: "dialog_privacy_policy",
                                                                          }
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.privacy_policy_title
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                            and\n                            "
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        $event.preventDefault()
                                                                        return _vm.ui__openModalByName(
                                                                          {
                                                                            name: "dialog_cancelation_policy",
                                                                          }
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.cancellation_policy_title
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  "v-checkbox",
                                                  bind,
                                                  false
                                                ),
                                                on
                                              )
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3749395599
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.cost.free_checkout &&
                  _vm.skip_checkout == 0 &&
                  (((_vm.only_save_card_at_advanced == 1 ||
                    _vm.advance_reservation_payment_checkout == 1) &&
                    !_vm.is_prepay) ||
                    ((_vm.prepay_payment == "1" ||
                      _vm.only_save_card_at_prepay == "1") &&
                      _vm.is_prepay))
                    ? [
                        _vm.$store.state.resources.config.google_recaptcha ==
                          "1" &&
                        _vm.$store.state.resources.config
                          .google_recaptcha_site_key != ""
                          ? [
                              _c("div", { staticClass: "mt-5" }, [
                                _c("h6", [
                                  _vm._v(
                                    "This site is protected by Google reCAPTCHA"
                                  ),
                                ]),
                              ]),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5" }, [
                    _c("div", { ref: "recaptcha" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c("errors-alert", {
                        attrs: { errors: _vm.v__getErrors() },
                      }),
                      _vm._v(" "),
                      typeof _vm.errorMessagesList !== "undefined" &&
                      typeof _vm.errorMessagesList === "object" &&
                      _vm.errorMessagesList.length !== 0 &&
                      _vm.v__getErrors().length === 0
                        ? _c("errors-alert", {
                            attrs: { errors: _vm.errorMessagesList },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "secondary",
                            disabled: _vm.$store.state.config.stepLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.go_back()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s("Back") +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            id: "stripe-card-button",
                            color: "primary",
                            loading: _vm.$store.state.config.stepLoading,
                            disabled: _vm.disabled_status,
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.is_prepay
                                  ? _vm.prepay_payment
                                    ? "Pay"
                                    : "Save"
                                  : !_vm.only_save_card_at_advanced &&
                                    _vm.advance_reservation_payment_checkout &&
                                    !_vm.cost.free_checkout &&
                                    _vm.skip_checkout == 0
                                  ? "Pay"
                                  : "Save"
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              : !_vm.is_using_square
              ? [
                  !_vm.cost.free_checkout &&
                  _vm.do_not_show_price_on_checkout == 0 &&
                  _vm.skip_checkout == 0 &&
                  !(
                    _vm.$store.state.model.reservation._type == "advance" &&
                    !_vm.$store.state.model.reservation.is_seasonal &&
                    _vm.no_priceing_checkouts == 1
                  )
                    ? [
                        ((_vm.prepay_payment || _vm.only_save_card_at_prepay) &&
                          _vm.is_prepay) ||
                        ((_vm.only_save_card_at_advanced ||
                          _vm.advance_reservation_payment_checkout) &&
                          !_vm.is_prepay)
                          ? _c("payment-widget", {
                              attrs: {
                                amount:
                                  (_vm.prepay_payment ||
                                    _vm.only_save_card_at_prepay) &&
                                  _vm.is_prepay
                                    ? parseFloat(
                                        _vm.prepay_total_price
                                      ).toFixed(2)
                                    : _vm.cost.amount_to_be_paid,
                                prepay: _vm.is_prepay,
                                "reservation-type": "advance",
                                "validation-id": _vm.v__validationId,
                              },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.cost.free_checkout &&
                  _vm.skip_checkout == 0 &&
                  (((_vm.only_save_card_at_advanced == 1 ||
                    _vm.advance_reservation_payment_checkout == 1) &&
                    !_vm.is_prepay) ||
                    ((_vm.prepay_payment == "1" ||
                      _vm.only_save_card_at_prepay == "1") &&
                      _vm.is_prepay))
                    ? [
                        _vm.$store.state.resources.config.google_recaptcha ==
                          "1" &&
                        _vm.$store.state.resources.config
                          .google_recaptcha_site_key != ""
                          ? [
                              _c("div", { staticClass: "mt-5" }, [
                                _c("h6", [
                                  _vm._v(
                                    "This site is protected by Google reCAPTCHA"
                                  ),
                                ]),
                              ]),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5" }, [
                    _c("div", { ref: "recaptcha" }),
                  ]),
                  _vm._v(" "),
                  _c("steps-navigation", {
                    attrs: {
                      "error-messages-list": _vm.errorMessagesList,
                      errors: _vm.v__getErrors(),
                      "next-button": _vm.is_prepay
                        ? _vm.prepay_payment
                          ? "Pay"
                          : "Save"
                        : !_vm.only_save_card_at_advanced &&
                          _vm.advance_reservation_payment_checkout &&
                          !_vm.cost.free_checkout &&
                          _vm.do_not_show_price_on_checkout == 0 &&
                          _vm.skip_checkout == 0 &&
                          !(
                            _vm.$store.state.model.reservation._type ==
                              "advance" &&
                            !_vm.$store.state.model.reservation.is_seasonal &&
                            _vm.no_priceing_checkouts == 1
                          )
                        ? "Pay"
                        : "Save",
                    },
                    on: {
                      "step-back": function ($event) {
                        return _vm.stepBack({ validate: false, submit: false })
                      },
                      "step-next": function ($event) {
                        return _vm.stepNext({ stay: true })
                      },
                    },
                  }),
                ]
              : _vm.is_using_square
              ? [
                  !_vm.cost.free_checkout && _vm.skip_checkout == 0
                    ? [
                        ((_vm.prepay_payment || _vm.only_save_card_at_prepay) &&
                          _vm.is_prepay) ||
                        ((_vm.only_save_card_at_advanced ||
                          _vm.advance_reservation_payment_checkout) &&
                          !_vm.is_prepay)
                          ? _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "mt-5" },
                                  [
                                    _c(
                                      "v-card-title",
                                      { staticClass: "grey lighten-4 p-2" },
                                      [
                                        (!_vm.is_prepay &&
                                          _vm.only_save_card_at_advanced) ||
                                        (_vm.is_prepay &&
                                          _vm.only_save_card_at_prepay)
                                          ? _c(
                                              "h5",
                                              {
                                                staticClass:
                                                  "m-0 font-weight-bold text-break",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            Please enter your credit card to save this reservation, you will not be charged at this time\n                        "
                                                ),
                                              ]
                                            )
                                          : _c("h4", { staticClass: "m-0" }, [
                                              _vm._v(
                                                "\n                            Reservation Total: "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "blue--text text--accent-4",
                                                },
                                                [
                                                  _vm._v(
                                                    "$" + _vm._s(_vm.amount)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.charge_50_percent ||
                                              _vm.charge_25_percent ||
                                              _vm.charge_10_percent ||
                                              _vm.charge_10_per_person ||
                                              _vm.charge_20_per_person ||
                                              _vm.charge_30_per_person
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "error--text text-break text--accent-4",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                ( " +
                                                          _vm._s(
                                                            _vm.deposite_text
                                                          ) +
                                                          " )\n                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "p-2" }, [
                                      (!_vm.is_prepay &&
                                        _vm.only_save_card_at_advanced) ||
                                      (_vm.is_prepay &&
                                        _vm.only_save_card_at_prepay)
                                        ? _c("h4", { staticClass: "m-0" }, [
                                            _c(
                                              "span",
                                              { staticClass: "error--text" },
                                              [_vm._v(" Reservation Total:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "blue--text text--accent-4",
                                              },
                                              [_vm._v("$" + _vm._s(_vm.amount))]
                                            ),
                                            _vm._v(" "),
                                            _vm.charge_50_percent ||
                                            _vm.charge_25_percent ||
                                            _vm.charge_10_percent ||
                                            _vm.charge_10_per_person ||
                                            _vm.charge_20_per_person ||
                                            _vm.charge_30_per_person
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "error--text text-break text--accent-4",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                ( " +
                                                        _vm._s(
                                                          _vm.deposite_text
                                                        ) +
                                                        " )\n                            "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.advance_reservation_payment_checkout &&
                                      !_vm.charge_50_percent &&
                                      !_vm.charge_25_percent &&
                                      !_vm.charge_10_percent &&
                                      !_vm.charge_10_per_person &&
                                      !_vm.charge_20_per_person &&
                                      !_vm.charge_30_per_person &&
                                      !_vm.only_save_card_at_advanced
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mt-5 error--text text-break",
                                            },
                                            [
                                              _vm._v(
                                                "\n                         Please enter your credit card information to complete the reservation\n                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        attrs: { id: "card-container" },
                                      }),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("with-validation", {
                        attrs: { field: "agreement" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ bind, on }) {
                                return [
                                  (
                                    _vm.is_prepay
                                      ? _vm.prepay_payment ||
                                        _vm.only_save_card_at_prepay
                                      : _vm.only_save_card_at_advanced ||
                                        _vm.advance_reservation_payment_checkout
                                  )
                                    ? _c(
                                        "v-checkbox",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(
                                                          "\n                        I have read and agree to the\n                         "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                                return _vm.ui__openModalByName(
                                                                  {
                                                                    name: "dialog_terms",
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.terms_and_conditions_title
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.show_sms_consent
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                            ,\n                             "
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        $event.preventDefault()
                                                                        return _vm.ui__openModalByName(
                                                                          {
                                                                            name: "dialog_sms_consent",
                                                                          }
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.sms_constent_title
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                        ,\n                         "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                                return _vm.ui__openModalByName(
                                                                  {
                                                                    name: "dialog_privacy_policy",
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.privacy_policy_title
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " \n                        and\n                         "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                $event.preventDefault()
                                                                return _vm.ui__openModalByName(
                                                                  {
                                                                    name: "dialog_cancelation_policy",
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.cancellation_policy_title
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            "v-checkbox",
                                            bind,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1711496687
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.cost.free_checkout &&
                  _vm.skip_checkout == 0 &&
                  (((_vm.only_save_card_at_advanced == 1 ||
                    _vm.advance_reservation_payment_checkout == 1) &&
                    !_vm.is_prepay) ||
                    ((_vm.prepay_payment == "1" ||
                      _vm.only_save_card_at_prepay == "1") &&
                      _vm.is_prepay))
                    ? [
                        _vm.$store.state.resources.config.google_recaptcha ==
                          "1" &&
                        _vm.$store.state.resources.config
                          .google_recaptcha_site_key != ""
                          ? [
                              _c("div", { staticClass: "mt-5" }, [
                                _c("h6", [
                                  _vm._v(
                                    "This site is protected by Google reCAPTCHA"
                                  ),
                                ]),
                              ]),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5" }, [
                    _c("div", { ref: "recaptcha" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c("errors-alert", {
                        attrs: { errors: _vm.v__getErrors() },
                      }),
                      _vm._v(" "),
                      typeof _vm.errorMessagesList !== "undefined" &&
                      typeof _vm.errorMessagesList === "object" &&
                      _vm.errorMessagesList.length !== 0 &&
                      _vm.v__getErrors().length === 0
                        ? _c("errors-alert", {
                            attrs: { errors: _vm.errorMessagesList },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "secondary",
                            disabled: _vm.$store.state.config.stepLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.go_back()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s("Back") +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            id: "card-button",
                            color: "primary",
                            loading: _vm.$store.state.config.stepLoading,
                            disabled: _vm.disabled_status,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.is_prepay
                                  ? _vm.prepay_payment
                                    ? "Pay"
                                    : "Save"
                                  : !_vm.only_save_card_at_advanced &&
                                    _vm.advance_reservation_payment_checkout &&
                                    !_vm.cost.free_checkout &&
                                    _vm.skip_checkout == 0
                                  ? "Pay"
                                  : "Save"
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : [
            _c(
              "div",
              { staticClass: "mt-5" },
              [
                _c("steps-navigation", {
                  attrs: {
                    "error-messages-list": _vm.errorMessagesList,
                    errors: _vm.v__getErrors(),
                    "next-button": "Save",
                  },
                  on: {
                    "step-back": function ($event) {
                      return _vm.stepBack({ validate: false, submit: false })
                    },
                    "step-next": function ($event) {
                      return _vm.stepNext({ stay: true })
                    },
                  },
                }),
              ],
              1
            ),
          ],
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.messageDialog.show,
            callback: function ($$v) {
              _vm.$set(_vm.messageDialog, "show", $$v)
            },
            expression: "messageDialog.show",
          },
        },
        [
          _c("message-modal", {
            attrs: {
              message: _vm.messageDialog.message,
              success: _vm.messageDialog.success,
              showPrintButton: false,
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }